/*global process*/
export const API_URL = process.env.REACT_APP_API_URL;
export const LOCALE = process.env.REACT_APP_LOCALE;
export const APP_ENV = process.env.REACT_APP_ENV;
export { analytics, numberWithCommas, getFlag, isENV, getHeader, getAppImages, getHelpText, downloadImage } from './helper';
// export { trans } from './lang';
